import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { Bank } from '../interface/bank';
import { environment } from '../../environments/environment';
import { DataService } from './data.service';
import { firstValueFrom } from 'rxjs';
import { DisableOrActive } from '../interface/disableOrActive';


interface BankApiResponse {
  banks: any[];
}
@Injectable({
  providedIn: 'root'
})
export class BankService {

  private _isFromMatrix = false;


  constructor(
    private _http: HttpClient,
    private dataService: DataService
  ) { }

  public async create(bank: Bank) {
    const url = `${environment.mkgoURL}/api/v1/bank`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const apiBank = bank.toAPI()
    const resp: any = await this._http.post(url, bank.toAPI(), options).pipe(first()).toPromise();
    return resp;
  }

  public async getAll(includeInactives = false, cnpj?: string): Promise<Bank[]> {
    const url = `${environment.mkgoURL}/api/v1/bank`;
    const options = await firstValueFrom(this.dataService.httpOptions(cnpj || this._isFromMatrix));
    const resp = await this._http.get(url, options).pipe(first(), map((r: any) => r.banks)).toPromise() as any[];
    const banks: Bank[] = [];
    if (resp && Array.isArray(resp)) {
      for (const obj of resp) {
        if(obj.available || includeInactives){
          banks.push(new Bank(obj))
        }
      }
      return banks;
    }
    return [];
  }

  /** @todo test */
  public async getById(id: string): Promise<Bank> {
    if (!id) {
      console.warn(new Error(`ID do banco inválido: ${id}`));
      return null;
    }
    const url = `${environment.mkgoURL}/api/v1/bank/${id}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.get(url, options).pipe(first(), map(r => new Bank(r))).toPromise();
    return resp;
  }

  public async update(bank: Bank) {
    if (!bank._id) {
      throw new Error("o ID do banco não foi informado, impossível atualizar");
    }
    const url = `${environment.mkgoURL}/api/v1/bank/${bank._id}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.put(url, bank.toAPI(), options).pipe(first()).toPromise();
    return resp;
  }

  /** @unused */
  public async delete(id: string) {
    if (!id) {
      throw new Error(`ID do banco inválido: ${id}`);
    }
    const url = `${environment.mkgoURL}/api/v1/bank/${id}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.delete(url, options).pipe(first()).toPromise();
    return resp;
  }

  public async getInactives(includeInactives = false, cnpj?: string): Promise<Bank[]> {
    const url = `${environment.mkgoURL}/api/v1/bank/inactives`;
    try {
      const options = await firstValueFrom(this.dataService.httpOptions(cnpj || this._isFromMatrix));
      const resp = await firstValueFrom(this._http.get(url, options)) as BankApiResponse;
      const banks: Bank[] = [];
      console.log(resp)
      if (resp && Array.isArray(resp.banks)) {
        const banks: Bank[] = resp.banks.map((obj: any) => new Bank(obj));
        return banks;
      }
    } catch (e){
      console.warn("Erro ao buscar os Bancos Inativos:", e)
    }
    return [];
  }

  public async inactiveOrActive(id: string, action: DisableOrActive) {
    if (!id) {
      throw new Error(`ID do banco inválido: ${id}`);
    }
    const url = `${environment.mkgoURL}/api/v1/bank/${id}/${action}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp = await firstValueFrom(this._http.put(url, {}, options));
    return resp;
  }
}
